import React from 'react';
import autoBind from 'auto-bind';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Header, Button, Icon } from 'semantic-ui-react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import {
  getBasePackages,
  getCustomPackages,
  showCreatePackageModal,
  showEditPackageModal,
  showDeleteConfirmation,
  doShowLogs,
  setLogModalShown,
  setLogPage,
} from 'state/billingPackage/actions';
import BasePackageTable from 'pages/BillingPackage/BasePackageTable';
import CustomPackageTable from 'pages/BillingPackage/CustomPackageTable';
import CustomPackageEditorModal from 'pages/BillingPackage/CustomPackageEditorModal';
import DeleteConfirmationModal from 'pages/BillingPackage/DeleteConfirmationModal';
import LogModal from 'components/LogModal';

export class BillingPackagePage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getBasePackages());
    dispatch(getCustomPackages());
  }

  onCreateCustomPackageClicked() {
    const { dispatch } = this.props;
    dispatch(showCreatePackageModal(true));
  }

  onEditPackageClicked(packageData) {
    const { dispatch } = this.props;
    dispatch(showEditPackageModal(true, packageData));
  }

  onDeletePackageClicked(packageData) {
    const { dispatch } = this.props;
    dispatch(showDeleteConfirmation(true, packageData));
  }

  onShowLogsClicked() {
    const { dispatch } = this.props;
    dispatch(doShowLogs());
  }

  render() {
    const {
      basePackages,
      customPackages,
      isLoading,
      dispatch,
      log,
    } = this.props;

    const upgradePackages = customPackages.filter(p => p.is_upgrade_product);
    const regularPackages = customPackages.filter(p => !p.is_upgrade_product);

    return (
      <Container fluid style={{ marginTop: '2em', padding: '0em 4em' }}>
        <SemanticToastContainer position="top-right" />

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '1em',
          }}
        >
          <div>
            <Header as="h1" style={{ marginBottom: '0.2em' }}>
              Billing Package
            </Header>
            <p style={{ color: '#666', margin: 0 }}>
              View and manage billing package information
            </p>
          </div>
          <Button
            primary
            icon
            labelPosition="left"
            onClick={this.onCreateCustomPackageClicked}
          >
            <Icon name="plus" />
            Create Customize Package
          </Button>
        </div>

        <Button basic color="black" onClick={this.onShowLogsClicked}>
          Show Logs
        </Button>

        <BasePackageTable
          packages={basePackages}
          isLoading={isLoading}
          onEdit={this.onEditPackageClicked}
          onDelete={this.onDeletePackageClicked}
        />

        <div style={{ marginTop: '2em' }}>
          <CustomPackageTable
            packages={upgradePackages}
            isLoading={isLoading}
            onEdit={this.onEditPackageClicked}
            isUpgradeTable
            title="Upgrade Package"
          />
        </div>

        <div style={{ marginTop: '2em' }}>
          <CustomPackageTable
            packages={regularPackages}
            isLoading={isLoading}
            onEdit={this.onEditPackageClicked}
            onDelete={this.onDeletePackageClicked}
          />
        </div>

        <CustomPackageEditorModal />
        <DeleteConfirmationModal />
        <LogModal
          title="Billing Package Logs"
          shown={log.shown}
          data={log.data}
          paging={log.paging}
          isLoading={log.isLoading}
          errors={log.errors}
          onPageChange={page => dispatch(setLogPage(page))}
          onClose={() => dispatch(setLogModalShown(false))}
        />
      </Container>
    );
  }
}

BillingPackagePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  basePackages: PropTypes.array,
  customPackages: PropTypes.array,
  isLoading: PropTypes.bool,
  log: PropTypes.shape({
    shown: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    paging: PropTypes.shape({
      page: PropTypes.number.isRequired,
      size: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    errors: PropTypes.array.isRequired,
  }).isRequired,
};

BillingPackagePage.defaultProps = {
  basePackages: [],
  customPackages: [],
  isLoading: false,
};

const mapStateToProps = state => ({
  basePackages: state.billingPackage.basePackages,
  customPackages: state.billingPackage.customPackages,
  isLoading: state.billingPackage.isLoading,
  log: state.billingPackage.log,
});

export default connect(mapStateToProps)(BillingPackagePage);
